import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";

(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.news_filter = {

    setnewsdatefilters:function(form){
        var year = $(form).find('[name=year_select]').val();
        var minmonth = $(form).find('[name=month_select]').val();
        var maxmonth = $(form).find('[name=month_select]').val();

        if(year != 'all')
        {

            if(minmonth == 'all')
            {
                minmonth = '01';
            }
            if(maxmonth == 'all')
            {
                maxmonth = '12';
            }

            var minddate = year + '-' + minmonth + '-' + '01';
            var maxddate = year + '-' + maxmonth + '-' + '31';

            $(form).find('[name="field_news_date_value[min]"]').val(minddate);
            $(form).find('[name="field_news_date_value[max]"]').val(maxddate);
        }
        else
        {
            $(form).find('[name="field_news_date_value[min]"]').val("");
            $(form).find('[name="field_news_date_value[max]"]').val("");
        }

    },

    submitform: function(form){
        $(form).find(".button").click();

    },


    attach: function (context, settings) {


      once("newsform", "#views-exposed-form-news-page-1", context).forEach(function (form) {


        $(form).find('[name=year_select]').change(function(){
            Drupal.behaviors.news_filter.setnewsdatefilters(form);
            Drupal.behaviors.news_filter.submitform(form);
        });

        $(form).find('[name=month_select]').change(function(){
            Drupal.behaviors.news_filter.setnewsdatefilters(form);
            Drupal.behaviors.news_filter.submitform(form);
        });

        if($(form).find('[name=year_select]').val() == 'all'){
            $(form).find('.form-item-month-select').hide();
        }
        else
        {
            $(form).find('.form-item-month-select').show();
        }


      });

    },
  };
})(jQuery, Drupal, drupalSettings);
